export default "__VITE_ASSET__CF_iciyG__"